import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    profileportal: localStorage.getItem("profileportal") || "No Portal",
    StoreLog: localStorage.getItem("StoreLog") || "False",
    themepref: localStorage.getItem("themepref"),
    accessGroup: localStorage.getItem("accessGroup") || "No Access",
    trust: localStorage.getItem("trust") || "No Trust",
    UserURN: localStorage.getItem("UserURN") || "No UserURN",
  },
  mutations: {
    SET_PORTAL_PROFILE(state, value) {
      state.profileportal = value;
      state.StoreLog = "True";
    },
    LOGOUT_USER(state, value) {
      state.profileportal = value;
      state.StoreLog = "False";
    },
    CHANGE_VIEW(state, value) {
      state.themepref = value;
      state.StoreLog = value;
    },
    SET_ACCESS_GROUP(state, value) {
      state.accessGroup = value;
    },

    SET_TRUST(state, value) {
      state.trust = value;
    },
  },
  actions: {
    updatePortalProfile({ commit }, payload) {
      commit("SET_PORTAL_PROFILE", payload);
    },
    logoutUser({ commit }, payload) {
      commit("LOGOUT_USER", payload);
    },
    setView({ commit }, payload) {
      commit("CHANGE_VIEW", payload);
    },
    setAccess({ commit }, payload) {
      commit("SET_ACCESS_GROUP", payload);
    },

    setTrust({ commit }, payload) {
      commit("SET_TRUST", payload);
    },
  },
  modules: {},
});
